import { url } from "../../../Functionalities/Config";
import { mediaUrl } from "../previewBlocks";

export const RED = "#EA4936";
export const INK = "#222222";
export const MUTED = "#666666";
export const BAND = "#ECECEC";

export const gutter = { marginLeft: 11, marginRight: 11 };
export const oneLine = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
export const sideScroll = { display: "flex", overflowX: "auto", scrollbarWidth: "none" };

export const picture = (path) => mediaUrl(path, url);
